import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'antd';
import { ApplicationDefinitionConditionalEditStore } from '../../stores';
import './AdditionalClassificationsActionsRenderer.less';
import { HasPermission } from '../../../authorization/components/HasPermission';
import { AppPermissions } from '../../../authorization/Permissions';

interface Props {
    store: ApplicationDefinitionConditionalEditStore;
    canEdit: boolean;
}

const AdditionalClassificationsActionsRenderer: React.FC<Props> = ({ store, canEdit }) => {
    if (!canEdit) {
        return null;
    }

    return (
        <HasPermission
            key="application-definition-conditional-additional-classifications-permission"
            entityId={store.project?.id}
            permissionClaim={AppPermissions.CanEditIotaApplications}
        >
            <div className="additional-classifications-actions-renderer">
                <Button
                    data-id="application-definition-conditional-new-classification"
                    type="primary"
                    onClick={store.openAddAdditionalClassificationModal}
                >
                    New Classification
                </Button>
            </div>
        </HasPermission>
    );
};

export default observer(AdditionalClassificationsActionsRenderer);
